/* wf-sort-dd – sorteringsväljare i husstil (2026-09-20).
   Förädlar native <select> (id wf-sort / SortBy / SortBy-mobile, [data-wf-sort-dd] eller Judge.me:s select.jdgm-sort-dropdown
   i produktsidans dragspel Kundrecensioner – laddas där via sections/wf-related.liquid) till en egen listbox.
   Selecten behålls dold i DOM: valt värde skrivs till den och 'input' + 'change' skickas, så att
   wf-collection-filter (change → apply) och Dawn facets (input → debouncedOnSubmit) fungerar oförändrat.
   Programmatiska tilldelningar (select.value = 'x') och ombyggda options speglas automatiskt.
   2026-09-20: Judge.me:s recensionsformulär (form.jdgm-form) ger även visningsnamnets format-select
   (name=reviewer_name_format, inline i etiketten "Visningsnamn (visas offentligt som …)") klassen jdgm-sort-dropdown –
   den ska INTE byggas om (bröt etiketten på tre rader), utan stilas kompakt inline i wf-pdp-reviews.css. */
(function(){
  'use strict';
  var SEL='select#wf-sort,select#SortBy,select#SortBy-mobile,select[data-wf-sort-dd],select.jdgm-sort-dropdown:not([name="reviewer_name_format"])';
  var uid=0, ALL=[];
  var CHEV='<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6"/></svg>';
  var CHECK='<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function closeAll(except){ ALL.forEach(function(d){ if(d!==except) d.close(); }); }

  function enhance(sel){
    if(!sel || sel.__wfSdd) return;
    if(sel.closest && sel.closest('.jdgm-form')) return; // formulärets selects (visningsnamnets format) lämnas native
    sel.__wfSdd=true;
    var id='wf-sdd-'+(++uid);
    var wrap=document.createElement('div'); wrap.className='wf-sdd'; wrap.setAttribute('data-wf-sdd','');
    var btn=document.createElement('button'); btn.type='button'; btn.className='wf-sdd__btn'; btn.id=id+'-btn';
    btn.setAttribute('aria-haspopup','listbox'); btn.setAttribute('aria-expanded','false'); btn.setAttribute('aria-controls',id+'-list');
    btn.innerHTML='<span class="wf-sdd__val"></span>'+CHEV;
    var list=document.createElement('ul'); list.className='wf-sdd__panel'; list.id=id+'-list'; list.setAttribute('role','listbox'); list.tabIndex=-1;
    // Etikett: <label for=select> eller aria-label
    var lab=sel.id?document.querySelector('label[for="'+sel.id+'"]'):null;
    if(lab){ if(!lab.id) lab.id=id+'-lab'; btn.setAttribute('aria-labelledby',lab.id+' '+btn.id); list.setAttribute('aria-labelledby',lab.id);
      lab.addEventListener('click',function(e){ e.preventDefault(); btn.focus(); }); }
    else if(sel.getAttribute('aria-label')){ btn.setAttribute('aria-label',sel.getAttribute('aria-label')); list.setAttribute('aria-label',sel.getAttribute('aria-label')); }
    var host=sel.parentNode; host.classList.add('wf-sdd-host');
    host.insertBefore(wrap,sel); wrap.appendChild(sel); wrap.appendChild(btn); wrap.appendChild(list);
    sel.classList.add('wf-sdd__native'); sel.setAttribute('tabindex','-1'); sel.setAttribute('aria-hidden','true');
    var open=false, items=[];

    function label(){ var o=sel.options[sel.selectedIndex]; return o?o.textContent.trim():''; }
    function render(){
      list.innerHTML='';
      items=[];
      Array.prototype.forEach.call(sel.options,function(o,i){
        var li=document.createElement('li'); li.className='wf-sdd__opt'; li.setAttribute('role','option'); li.tabIndex=-1;
        li.setAttribute('data-value',o.value); li.setAttribute('aria-selected',o.selected?'true':'false'); li.id=id+'-opt-'+i;
        li.innerHTML='<span></span>'+CHECK; li.firstChild.textContent=o.textContent.trim();
        li.addEventListener('click',function(){ choose(i); });
        list.appendChild(li); items.push(li);
      });
      sync();
    }
    function sync(){
      btn.querySelector('.wf-sdd__val').textContent=label();
      items.forEach(function(li,i){ var on=i===sel.selectedIndex; li.setAttribute('aria-selected',on?'true':'false'); if(on) list.setAttribute('aria-activedescendant',li.id); });
    }
    function choose(i){
      var changed=sel.selectedIndex!==i;
      sel.selectedIndex=i; sync(); api.close(); btn.focus();
      if(changed){
        try{ sel.dispatchEvent(new Event('input',{bubbles:true})); }catch(e){}
        try{ sel.dispatchEvent(new Event('change',{bubbles:true})); }catch(e){}
      }
    }
    function place(){
      wrap.classList.remove('wf-sdd--up');
      var r=btn.getBoundingClientRect(), need=Math.min(list.scrollHeight+12, 360);
      if(window.innerHeight-r.bottom<need && r.top>need) wrap.classList.add('wf-sdd--up');
    }
    var api={
      open:function(){ if(open) return; closeAll(api); open=true; place(); wrap.classList.add('is-open'); btn.setAttribute('aria-expanded','true'); },
      close:function(){ if(!open) return; open=false; wrap.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); },
      el:wrap
    };
    ALL.push(api);
    function focusItem(i){ if(!items.length) return; i=(i+items.length)%items.length; items[i].focus(); }
    btn.addEventListener('click',function(){ if(open) api.close(); else api.open(); });
    btn.addEventListener('keydown',function(e){
      if(e.key==='ArrowDown'||e.key==='ArrowUp'){ e.preventDefault(); api.open(); focusItem(e.key==='ArrowDown'?sel.selectedIndex:sel.selectedIndex-1); }
      else if(e.key==='Escape'&&open){ e.preventDefault(); api.close(); }
    });
    list.addEventListener('keydown',function(e){
      var cur=items.indexOf(document.activeElement);
      if(e.key==='ArrowDown'){ e.preventDefault(); focusItem(cur+1); }
      else if(e.key==='ArrowUp'){ e.preventDefault(); focusItem(cur-1); }
      else if(e.key==='Home'){ e.preventDefault(); focusItem(0); }
      else if(e.key==='End'){ e.preventDefault(); focusItem(items.length-1); }
      else if(e.key==='Enter'||e.key===' '){ e.preventDefault(); if(cur>=0) choose(cur); }
      else if(e.key==='Escape'){ e.preventDefault(); api.close(); btn.focus(); }
      else if(e.key==='Tab'){ api.close(); }
    });
    // Speglar programmatiska ändringar: select.value = 'x' / selectedIndex, samt native change
    try{
      var proto=HTMLSelectElement.prototype, dv=Object.getOwnPropertyDescriptor(proto,'value'), di=Object.getOwnPropertyDescriptor(proto,'selectedIndex');
      if(dv&&dv.set) Object.defineProperty(sel,'value',{configurable:true,get:function(){return dv.get.call(sel);},set:function(v){dv.set.call(sel,v);sync();}});
      if(di&&di.set) Object.defineProperty(sel,'selectedIndex',{configurable:true,get:function(){return di.get.call(sel);},set:function(v){di.set.call(sel,v);sync();}});
    }catch(e){}
    sel.addEventListener('change',sync);
    if(window.MutationObserver){ new MutationObserver(render).observe(sel,{childList:true,subtree:true,attributes:true,attributeFilter:['selected']}); }
    render();
  }

  function scan(root){ (root||document).querySelectorAll(SEL).forEach(enhance); }
  document.addEventListener('click',function(e){ ALL.forEach(function(d){ if(d.el.classList.contains('is-open') && !d.el.contains(e.target)) d.close(); }); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeAll(); });
  window.addEventListener('resize',function(){ closeAll(); });
  function boot(){
    scan();
    if(window.MutationObserver){
      new MutationObserver(function(muts){
        for(var i=0;i<muts.length;i++){ var a=muts[i].addedNodes; for(var j=0;j<a.length;j++){ var n=a[j]; if(n.nodeType!==1) continue; if(n.matches&&n.matches(SEL)) enhance(n); else if(n.querySelector) scan(n); } }
      }).observe(document.body,{childList:true,subtree:true});
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  window.wfSortDd={enhance:enhance,scan:scan,closeAll:closeAll};
})();
